import * as React from "react";
import { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useLocation, useNavigate } from "react-router-dom";

import TriceTabItem from "./TriceTabItem";
import { Typography } from "@mui/material";
import ShuffleTabItem from "./ShuffleTabItem";

const a11yProps = (index: number) => {
  return {
    id: `tokens-tab-${index}`,
    "aria-controls": `tokens-tabpanel-${index}`,
  };
};

const MenuTabs = () => {
    useEffect(() => {
      console.log(`MenuTabs`);

      return () => {
      }
    }, [])

  const location = useLocation();
  const navigate = useNavigate();

  const getTabIndex = () => {
    return location.pathname === "/tokens/shuffle" ? 0 : 1;
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const paths = ["/tokens/shuffle", "/tokens/trice"];
    navigate(paths[newValue]);
  };

  return (
    <Box sx={{ width: "100%", mt: { xs: "55px", md: "61px" } }}>
      <Box
        sx={{
          borderBottom: 0.5,
          borderColor: "#BDBDBD",
          mb: { xs: "44px", md: "58px" },
        }}
      >
        <Tabs
          sx={{
            minHeight: "0px",
            "& .MuiTab-root": {
              p: 0,
              pb: "5.83px",
              minWidth: "80px",
              minHeight: "0px",
              color: "#00000080",
            },

            "& .MuiTab-root.Mui-selected": {
              color: "#242424",
            },

            "& .MuiTabs-indicator": {
              height: "2px",
              background: "#357AFF",
            },
          }}
          value={getTabIndex()}
          onChange={handleChange}
          aria-label="tokens tabs example"
        >
          <Tab
            label={<Typography variant="h3">SFL</Typography>}
            {...a11yProps(0)}
          />
          <Tab
            label={<Typography variant="h3">TRI</Typography>}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      {getTabIndex() === 0 ? <ShuffleTabItem /> : <TriceTabItem />}
    </Box>
  );
};

export default MenuTabs;
